/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { clubMembershipGetDataInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmClubMemberMgmtGetDataResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetMembership Input Action
 */
export class GetMembershipInput implements Msdyn365.IActionInput {
  public input: IDataServiceRequest;
  constructor(input: IDataServiceRequest) {
    this.input = input;
  }

  public shouldCacheOutput = () => true;

  public getCacheKey = () => `IGetMembershipInput`;
  public getCacheObjectType = () => 'IGetMembershipInput';
  public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetMembershipData extends IrsmClubMemberMgmtGetDataResponse {}

export interface IInputRequirements {
  customerId: string;
}

export const createGetMembershipInput = (
  args: Msdyn365.ICreateActionContext
): GetMembershipInput => {
  const accNumber = args.requestContext.user.customerAccountNumber || '';
  return new GetMembershipInput(
    clubMembershipGetDataInput(
      accNumber
    ),
  );
};

export async function getMembershipAction(
  input: GetMembershipInput,
  ctx: Msdyn365.IActionContext,
): Promise<IGetMembershipData> {
  return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<IGetMembershipData>> getMembershipAction,
  input: createGetMembershipInput,
});